import React, { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminTopBar from "./AdminTopBar";
import AdminSidebar from "./AdminSidebar";
import styles from "../styles/AdminLayout.module.css";
import { getAdminNavItemByPath } from "../navigation";

export function AdminAppShell({ onLogout }) {
  const location = useLocation();
  const currentItem = useMemo(() => getAdminNavItemByPath(location.pathname), [location.pathname]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname, location.search]);

  return (
    <div className={styles.app}>
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className={styles.shell}>
        <AdminTopBar
          currentItem={currentItem}
          onMenuClick={() => setSidebarOpen((prev) => !prev)}
          onLogout={onLogout}
        />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminAppShell;
